import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header-card-modern" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-bg-decoration" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle-decoration circle-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle-decoration circle-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle-decoration circle-3" })
], -1)
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "logo-section" }
const _hoisted_5 = { class: "logo-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "logo-pulse" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"4rem"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-section" }
const _hoisted_10 = { class: "title-wrapper" }
const _hoisted_11 = { class: "main-title" }
const _hoisted_12 = { class: "title-gradient" }
const _hoisted_13 = { class: "subtitle-wrapper" }
const _hoisted_14 = { class: "subtitle-icon" }
const _hoisted_15 = { class: "subtitle-text" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "header-divider" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "back-button-wrapper"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "back-text" }, "Kembali", -1)

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.is_loading)
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                width: "65px",
                src: require(`@/assets/logo.png`),
                alt: "",
                class: "logo-image"
              }, null, 8, _hoisted_8))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.icon), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.subtitle), 1)
          ])
        ])
      ]),
      _hoisted_16,
      (_ctx.clickable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", {
              class: "back-button",
              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'chevron-left'] }),
              _hoisted_18
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}